var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportExportActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42907 1.07084L0.871573 3.62834C0.578239 3.9125 0.779906 4.4075 1.19241 4.4075H2.83324V9.91667C2.83324 10.4208 3.24574 10.8333 3.74991 10.8333C4.25407 10.8333 4.66657 10.4208 4.66657 9.91667V4.4075H6.30741C6.71991 4.4075 6.92157 3.9125 6.62824 3.62834L4.07074 1.07084C3.98506 0.986858 3.86988 0.939819 3.74991 0.939819C3.62994 0.939819 3.51475 0.986858 3.42907 1.07084ZM10.1666 13.5925V8.08334C10.1666 7.57917 9.75407 7.16667 9.24991 7.16667C8.74574 7.16667 8.33324 7.57917 8.33324 8.08334V13.5925H6.69241C6.27991 13.5925 6.07824 14.0875 6.37157 14.3717L8.92907 16.92C9.11241 17.0942 9.39657 17.0942 9.57991 16.92L12.1374 14.3717C12.4307 14.0875 12.2199 13.5925 11.8166 13.5925H10.1666Z",
    fill: "#0FA479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportExportActive);
export default __webpack_public_path__ + "static/media/import_export_active.d1e49852d8887617746bcd8e8f0ca938.svg";
export { ForwardRef as ReactComponent };